import {useSelector} from 'react-redux'
import {useGetIsOfferSoldOut} from 'hooks/useGetIsOfferSoldOut/useGetIsOfferSoldOut'
import {
  getRoomOfferAccessConfig,
  getRoomOfferById
} from 'modules/searchApi/selectors'

import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {OfferAccessFlow} from '../../../../modules/sapiSearch/constants'

export const RoomOfferAccessFlowLabel = ({offerId}: {offerId: string}) => {
  const offer = useSelector(state => getRoomOfferById(state, offerId))
  const isOfferSoldOut = useGetIsOfferSoldOut({offer})

  const flowType = useSelector(state =>
    getRoomOfferAccessConfig(state, offerId)
  )

  if (flowType !== OfferAccessFlow.RegularDeal && !isOfferSoldOut)
    return (
      <Text colorPath="content.brand.primary" variant="titleS" align="right">
        {flowType === OfferAccessFlow.AppLocked ? (
          <FormattedMessageWrapper
            id="offerAccessFlow.appLocked"
            defaultMessage="Book on Vio app"
          />
        ) : flowType === OfferAccessFlow.PrivateLockedDeal ? (
          <FormattedMessageWrapper
            id="offerAccessFlow.signInToBookLabel"
            defaultMessage="Sign in to book"
          />
        ) : null}
      </Text>
    )

  return null
}
